export const skillsData = [
    {
        label: "FRONT END",
        data: [
            {
                skillName: "HTML",
                percentage: "90",
            },
            {
                skillName: "CSS",
                percentage: "80",
            },
            {
                skillName: "JAVASCRIPT",
                percentage: "80",
            },
            {
                skillName: "REACT JS",
                percentage: "80",
            },
        ],
    },
    {
        label: "BACKEND and DATABASES",
        data: [
            {
                skillName: "ASP DotNet",
                percentage: "90",
            },
            {
                skillName: "DotNet MVC",
                percentage: "80",
            },
            {
                skillName: "Entity FRAMEWORK",
                percentage: "85",
            },
            {
                skillName: "SQL",
                percentage: "70",
            },
            {
                skillName: "Mongo DB",
                percentage: "50",
            },
        ],
    },
    {
        label: "ANALYTIC TOOLS",
        data: [
            {
                skillName: "MS EXCEL",
                percentage: "90",
            },
            {
                skillName: "POWER BI",
                percentage: "80",
            },
            {
                skillName: "TABLEAU",
                percentage: "85",
            },
            {
                skillName: "R PROGRAMMING",
                percentage: "70",
            },
            {
                skillName: "PYTHON",
                percentage: "70",
            },
        ],
    },
]